import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/authSlice.ts";
import NavBarItem from "./NavBarItem.tsx";
import { RootState } from "../../store/index.ts";
import { incidentMenuTo, Routes } from "./Routes.tsx";
import DropdownComponent from "./DropdownComponent.tsx";
import NotificationBell from "./NotificationBell.tsx";
import DirectBossStatusProvider from "./DirectBossStatusProvider.tsx";
import { can } from "../../auth/can.ts";

function NavBar() {
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [active, setActive] = React.useState<string>("");
  React.useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    // Para rutas de sucursal, usar la segunda parte; para otras, usar la primera
    if (pathParts[0] === "sucursal" && pathParts.length > 1) {
      setActive(pathParts[1]);
    } else {
      setActive(pathParts[0] || "");
    }
  }, [location.pathname]);


  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark bg-dark"
      style={{
        margin: '12px 12px 0 12px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.18)',
        position: 'sticky',
        top: 12,
        zIndex: 1000,
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        paddingTop: 6,
        paddingBottom: 6,
        minHeight: 'unset',
      }}
    >
      <div className="container-fluid">
        <DirectBossStatusProvider />
        <a
          className="navbar-brand"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <div className="brand" style={{ padding: '4px 8px' }}>
            <div className="w-50px" style={{ width: 44 }}>
              <img
                src="../../../../assets/img/logo/logo_chili_rojo.png"
                alt=""
                className="w-100"
              />
            </div>
          </div>
        </a>
        {/* Una sola instancia: evita doble polling (antes había campanita en móvil + desktop). */}
        <div className="d-flex align-items-center ms-auto me-2 order-lg-last">
          <ul className="navbar-nav flex-row align-items-center mb-0">
            <NotificationBell />
          </ul>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav flex-wrap">
            {Routes.map((route) => {
              const canAccessRoute = () => {
                if (!route.requiredPermission) {
                  return false;
                }
                if (route.to === "/mi-expediente") {
                  return (
                    can("proceedings.view", user) &&
                    can("labor_permissions.request", user) &&
                    !can("partners.edit", user)
                  );
                }
                return can(route.requiredPermission, user);
              };

              if (canAccessRoute()) {
                return (
                  <NavBarItem
                    key={route.name}
                    active={active}
                    name={route.name}
                    to={
                      route.to === "/incidencias"
                        ? incidentMenuTo(user)
                        : route.to
                    }
                    activeKey={route.activeKey}
                    icon={route.icon}
                    childrenRoutes={route.children}
                    isNew={route.isNew}
                    disabled={route.disabled}
                  />
                );
              }
              return null;
            })}
            <li className="nav-item d-block d-md-none">
              <DropdownComponent />
            </li>
          </div>
        </div>
      </div>
      <div
        className="collapse navbar-collapse"
        id="navbarTogglerDemo03"
        style={{ paddingRight: "2%" }}
      >
        <ul className="navbar-nav mr-auto mt-2 mt-lg-0 mr-2 align-items-center">
          <li className="nav-item">
            <DropdownComponent />
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
